module.exports = __webpack_public_path__ + "static/media/icon-4.2625c902.svg";